import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth'
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAc-cEhh570qDBbJCOgHVeh2Kyi2qaKWss",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sistema2-0-prod.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "sistema2-0-prod",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "sistema2-0-prod.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "200982531543",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:200982531543:web:ef62ae47881fa5cd3a0f92",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-N1V4LJRXHF"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)

const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");

export { db };
